module.exports = __webpack_public_path__ + "img/chevron-down.a8518586.svg";